// removed by extract-text-webpack-plugin
module.exports = {"projectimg":"src-components-Page----services-module---projectimg---2BSQf","serviceSection":"src-components-Page----services-module---serviceSection---2Q28l"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Page/services.module.scss
// module id = 79
// module chunks = 19817326959855 219805994829571 267660657819475